/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Component, input, computed, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

import { MovieLoadingComponent, MovieDetailSkeletonComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie, MoviePress } from '@usheru-hff/shared/domain';
import { SwiperDirective } from '@usheru-hff/shared/ui-swiper';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';

import { MovieRatingComponent } from '../movie-rating/movie-rating.component';
/**
 * Component to display the reviews from a movie.
 */
@Component({
  standalone: true,
  selector: 'ush-movie-reviews',
  templateUrl: './movie-reviews.component.html',
  styleUrls: ['./movie-reviews.component.scss'],
  imports: [SharedUtilsModule, SwiperDirective, MovieRatingComponent, MovieDetailSkeletonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MovieReviewsComponent implements MovieLoadingComponent {
  readonly movie = input<Movie | null>(null);
  readonly isLoadingData = input(false);
  readonly pressReviews = computed(() => this.addDoubleQuotes(this.movie()?.reviews || null));

  readonly design = input<'standard' | 'carousel'>('standard');

  readonly reviewsSwiperConfig: SwiperOptions = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    spaceBetween: 10,
    scrollbar: false,
    navigation: true,
    loop: true,
    autoplay: {
      delay: 5000
    }
  };

  addDoubleQuotes(reviews: MoviePress[] | null) {
    if (!reviews) return null;
    return reviews.map(review => {
      if (!review.quote) return review;
      let quote = review.quote.trim();
      if (!quote.startsWith('"')) {
        quote = `"${quote}`;
      }
      if (!quote.endsWith('"')) {
        quote = `${quote}"`;
      }
      review.quote = quote;
      return review;
    });
  }

  numToArray(num: number) {
    return new Array(num);
  }
}
